import React from "react";

import useNavigationCollapse from "../../../hooks/useNavigationCollapse";
import BackOfficeLogo from "../../../common/BackOfficeLogo";

const NavigationLogo = () => {
  const { isCollapsed } = useNavigationCollapse();

  return <BackOfficeLogo showWordmark={!isCollapsed} size="nav" />;
};

export default NavigationLogo;
